import { gql, useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import "./ERPUserLogs.scss";

const LogById = gql`
  query GetUserErrorLogById($id: ID) {
    getUserErrorLogById(id: $id) {
      id
      UserName
      Error_Message
      Error
      requestUrl
      PageName
      logGUID
      IP_Address
      Route
      message
      tenantId
      UserId
      accType
      Account_UniqueID
      AccountID
      Type_Of_User
      ClientIP
      Status_Code
      User_Agent
      CPU_Usage
      Memory_Usage
      TenantID
      Document_Ids
      Document_uniqueId
      createdData
      previousData
      updatedData
      deletedData
      lockedData
      unlockedData
      Company_Code
      Branch_Code
      createdAt
      updatedAt
    }
  }
`;
const ErrorUserLogs = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction, allFieldsData }) => {
  const [toggle, settoggle] = useState(show ? show : false);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const [userLogs, setuserlogs] = useState({});
  const fielddata = fielddataRedux?.Error_Logs?.Selected_Row;
  const [GetData, { data }] = useLazyQuery(LogById);

  const dispatch = useDispatch();

  useEffect(() => {
    if (data?.getUserErrorLogById) {
      setuserlogs(data?.getUserErrorLogById);
    }
  }, [data]);
  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });
  };

  useEffect(() => {
    if (fielddata?.id) {
      GetData({ variables: { id: fielddata.id } });
    }
  }, [fielddata, GetData]);

  const renderData = (label, value) => {
    let displayValue = value;

    // Check if the value is a string that can be parsed as JSON
    // This will handle both createdData and deletedData

    if (label === "DeletedData") {
      const parsedJson = JSON.parse(value);

      displayValue = <pre>{parsedJson}</pre>;
    }
    if (typeof value === "string" && (value.startsWith("{") || value.startsWith("["))) {
      try {
        const parsedJson = JSON.parse(value);
        displayValue = <pre>{JSON.stringify(parsedJson, null, 2)}</pre>;
      } catch (e) {
        // If parsing fails, display the original value
        console.error("Error parsing JSON: ", e);
      }
    }

    return (
      <div className="userlogs-data">
        <div className="userlable">{label}:</div>
        <div>{displayValue}</div>
      </div>
    );
  };

  return (
    <div>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={"User Logs"}
        //id={allFieldsData && allFieldsData?.id ? allFieldsData.id : id}
      >
        <>
          <div className="formContainer">
            <div className="custom-modal-userlogs">
              <div className="content-userlogs">
                {/* <div className="side-by-side-container">
                  <div className="data-container">{fielddata && renderData("CreatedData", fielddata.createdData)}</div>
                  <div className="data-container">
                    {fielddata && renderData("PreviousData", fielddata.previousData)}
                  </div>
                </div> */}
                {Object.entries(userLogs || {}).map(([key, value], index, array) => {
                  // if (key === "createdData" || key === "previousData") {
                  //   return null; // We will render them separately below
                  // }
                  return (
                    <div key={key} className={`entry-container ${index === array.length - 1 ? "last-entry" : ""}`}>
                      {renderData(key.charAt(0).toUpperCase() + key.slice(1), value)}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            submitType={submitType}
            handleformclose={() => {
              Closeformfunction();
              settoggle(!toggle);
            }}
          />
        </>
      </Reactportal>
    </div>
  );
};

export default ErrorUserLogs;
